export default "__VITE_ASSET__CqcUEDSc__"